export enum LabelFormat {
	Text,
	Date,
	WeekDate,
	WeekRange,
	MonthDate
}
